import { useAppContext } from '../../../context/AppContext';
import { postData } from '../../../services/postData';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../../assets/images/logo.webp';
export const RequestPasswordResetPage = () => {
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { base_url } = useAppContext();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            console.log('Requesting password reset for email:', email);
            const response = await postData(null, `${base_url}/apis/admin/request-password-reset`, {
                email
            });

            if (response && response.msg === 'Password reset token sent') {
                if (window.showAlert) {
                    window.showAlert(200, 'Password reset instructions have been sent to your email address.');
                }
            } else {
                if (window.showAlert) {
                    window.showAlert(400, response?.message || 'Failed to send password reset email. Please try again.');
                }
            }
        } catch (err) {
            if (window.showAlert) {
                window.showAlert(500, 'An error occurred. Please try again.');
            }
            console.error('Password reset request error:', err);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="modal-overlay auth-page">
            <div className="auth-page__header">
                <img
                    src={logo}
                    alt="Company Logo"
                    className="auth-page__logo"
                />
                <h1 className="auth-page__title">
                    Reset Password
                </h1>
                <p className="auth-page__subtitle">
                    Enter your email address to receive reset instructions
                </p>
            </div>

            <div className="modal-content auth-page__card">
                <h2 className="modal-title">Request Password Reset</h2>

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="email" className="form-label">
                            Email Address
                        </label>
                        <input
                            type="email"
                            id="email"
                            className="form-input"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            placeholder="Enter your email address"
                        />
                    </div>

                    <div className="form-actions">
                        <button
                            type="submit"
                            className="btn btn-primary btn--block"
                            disabled={isLoading}
                        >
                            {isLoading ? 'Sending...' : 'Send Reset Instructions'}
                        </button>
                    </div>
                </form>

                <div className="auth-page__footer">
                    <p className="auth-page__footer-p">
                        Remember your password?{' '}
                        <Link to="/login" className="text-link">
                            Sign in here
                        </Link>
                    </p>
                    <p className="auth-page__footer-p">
                        Don't have an account?{' '}
                        <Link to="/signup" className="text-link">
                            Create one here
                        </Link>
                    </p>
                </div>
            </div>
        </div>
    );
};
